import styled from '../../../config/theme'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    width: calc(50% - 5px);
    margin-bottom: 10px;

    &:nth-child(even) {
      margin-left: 5px;
    }
    &:nth-child(odd) {
      margin-right: 5px;
    }

    @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
      width: 100%;
      margin-right: 0 !important;
      margin-left: 0 !important;
      margin-bottom: 10px;
    }
  }
`

const NoRealties = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  > img {
    height: 200px;
    width: 200px;
    object-fit: contain;
  }

  > * {
    margin-bottom: 20px;
  }
`

export {
  Container,
  NoRealties,
}
